import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewRestoreAction {
  public static readonly type = '[AllocationViewRestoreAction] Uli Restore';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewRestoreActionSetInitialState {
  public static readonly type = '[AllocationViewRestoreAction] Set Initial State';
}
